import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useGeoPrice } from '../hooks/useGeoPrice';
const PURCHASE_URL = 'https://pay.hotmart.com/R104430088E?bid=1770999394323';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  const {
    price,
    loading
  } = useGeoPrice();
  const displayPrice = loading ? '$27 USD' : price;
  useEffect(() => {
    function handleScroll() {
      setVisible(window.scrollY > 600);
    }
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-357">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#0f0529]/95 backdrop-blur-sm border-t border-white/10" data-id="element-358">
          <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between gap-4" data-id="element-359">
            <div className="hidden sm:block" data-id="element-360">
              <p className="text-white text-sm font-semibold" data-id="element-361">
                Super Pack Completo
              </p>
              <div className="flex items-center gap-2" data-id="element-362">
                <span className="text-gray-500 line-through text-xs" data-id="element-363">
                  $97 USD
                </span>
                <span className="text-amber-400 text-xs font-bold" data-id="element-364">
                  {displayPrice}
                </span>
                <span className="text-red-400 text-[10px] font-bold" data-id="element-365">-72%</span>
              </div>
            </div>
            <a href={PURCHASE_URL} className="cta-hero-glow flex-shrink-0 inline-flex flex-col items-center justify-center bg-amber-500 hover:bg-amber-400 text-black px-5 sm:px-6 py-2 sm:py-2.5 rounded-xl transition-colors w-full sm:w-auto text-center" data-id="element-366">
              <span className="font-black text-sm sm:text-base" data-id="element-367">
                OFERTA — {displayPrice}
              </span>
              <span className="text-black/50 text-[9px] sm:text-[10px] font-semibold" data-id="element-368">
                ⚡ Tiempo limitado
              </span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}